(() => {
  'use strict';

  const buildFaq = (scope = document) => {
    scope.querySelectorAll('.sst-main-page--faq > .rte').forEach((container) => {
      if (container.dataset.sstFaqReady) return;
      container.dataset.sstFaqReady = 'true';

      const nodes = [...container.children];
      const groups = [];
      let current = [];

      const flush = () => {
        if (current.length) groups.push(current);
        current = [];
      };

      nodes.forEach((node) => {
        const text = node.textContent.replace(/\u00a0/g, ' ').trim();
        if (!text) {
          flush();
          return;
        }
        current.push(node);
      });
      flush();

      if (!groups.length) return;

      const fragment = document.createDocumentFragment();
      groups.forEach((group, index) => {
        const [question, ...answers] = group;
        if (!question || !answers.length) {
          group.forEach((node) => fragment.appendChild(node));
          return;
        }

        const details = document.createElement('details');
        details.className = 'sst-faq';
        if (index === 0) details.open = true;

        const summary = document.createElement('summary');
        summary.className = 'sst-faq__question';

        const questionText = document.createElement('span');
        questionText.className = 'sst-faq__question-text';
        questionText.textContent = question.textContent.replace(/\u00a0/g, ' ').trim();

        const icon = document.createElement('span');
        icon.className = 'sst-faq__icon';
        icon.setAttribute('aria-hidden', 'true');

        const answer = document.createElement('div');
        answer.className = 'sst-faq__answer';
        answers.forEach((node) => answer.appendChild(node));

        summary.append(questionText, icon);
        details.append(summary, answer);
        fragment.appendChild(details);
      });

      container.replaceChildren(fragment);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => buildFaq(), { once: true });
  } else {
    buildFaq();
  }

  document.addEventListener('shopify:section:load', (event) => buildFaq(event.target));
})();
